import {
  LinkIcon,
  PhoneIcon,
  EmailIcon,
  ShopIcon,
  ScheduleIcon,
  GetStartedIcon,
  WebsiteIcon,
  HelpIcon,
  AppIcon,
  BuyIcon,
  AccountIcon,
  LearnMoreIcon,
  LocationIcon,
  DemoIcon,
  SignupIcon,
  ServicesIcon
} from '../components/UI/ButtonIcons';

/**
 * Maps icon string values to their corresponding React icon components
 * @param {string} iconValue - The string value of the icon (e.g., 'phone', 'email')
 * @returns {React.Component} - The corresponding icon component, defaults to LinkIcon if not found
 */
export const getIconComponent = (iconValue) => {
  const iconMap = {
    'link': LinkIcon,
    'phone': PhoneIcon,
    'email': EmailIcon,
    'shop': ShopIcon,
    'schedule': ScheduleIcon,
    'get-started': GetStartedIcon,
    'website': WebsiteIcon,
    'help': HelpIcon,
    'app': AppIcon,
    'buy': BuyIcon,
    'account': AccountIcon,
    'learn-more': LearnMoreIcon,
    'location': LocationIcon,
    'demo': DemoIcon,
    'signup': SignupIcon,
    'services': ServicesIcon,
  };
  
  return iconMap[iconValue] || LinkIcon; // Default to LinkIcon if not found
};

/**
 * Gets all available icon options for dropdowns/forms
 * @returns {Array} - Array of icon options with value, label, and icon component
 */
export const getIconOptions = () => {
  return [
    { value: 'link', label: 'Link', icon: LinkIcon },
    { value: 'phone', label: 'Phone', icon: PhoneIcon },
    { value: 'email', label: 'Email', icon: EmailIcon },
    { value: 'shop', label: 'Shop', icon: ShopIcon },
    { value: 'schedule', label: 'Schedule', icon: ScheduleIcon },
    { value: 'get-started', label: 'Get Started', icon: GetStartedIcon },
    { value: 'website', label: 'Website', icon: WebsiteIcon },
    { value: 'help', label: 'Help', icon: HelpIcon },
    { value: 'app', label: 'App', icon: AppIcon },
    { value: 'buy', label: 'Buy', icon: BuyIcon },
    { value: 'account', label: 'Account', icon: AccountIcon },
    { value: 'learn-more', label: 'Learn More', icon: LearnMoreIcon },
    { value: 'location', label: 'Location', icon: LocationIcon },
    { value: 'demo', label: 'Demo', icon: DemoIcon },
    { value: 'signup', label: 'Signup', icon: SignupIcon },
    { value: 'services', label: 'Services', icon: ServicesIcon },
  ];
};

/**
 * Validates if an icon value is supported
 * @param {string} iconValue - The icon value to validate
 * @returns {boolean} - True if the icon value is supported
 */
export const isValidIconValue = (iconValue) => {
  const validValues = [
    'link', 'phone', 'email', 'shop', 'schedule', 'get-started',
    'website', 'help', 'app', 'buy', 'account', 'learn-more',
    'location', 'demo', 'signup', 'services'
  ];
  return validValues.includes(iconValue);
};
